import ImageGalleryThumbnail from './ImageGalleryThumbnail';

export default ImageGalleryThumbnail;
